import React, { FC } from 'react'
import { ContentfulRichTextGatsbyReference, renderRichText, RenderRichTextData } from "gatsby-source-contentful/rich-text"
import { BLOCKS } from '@contentful/rich-text-types'

import { textOptions } from './Content.utils'

import { ContentDIV } from './Content.styles'
import ContentImages from './components/ContentImages/ContentImages'
import ContentBlocks from './components/ContentBlocks/ContentBlocks'

export { ContentDIV }

const Content: FC<{
  className?: string
  content?: RenderRichTextData<ContentfulRichTextGatsbyReference>
}> = ({
  className = "main",
  content
}) => (
    <ContentDIV className={`Content${className ? ` ${className}` : ""}`}>
      {content && renderRichText(content, {
        ...textOptions,
        renderNode: {
          ...textOptions.renderNode,
          [BLOCKS.EMBEDDED_ASSET]: ({
            data: { target }
          }) => {
            return <ContentImages contentful_id={target.contentful_id} images={[target]} />
          },
          [BLOCKS.EMBEDDED_ENTRY]: ({
            data: { target }
          }) => {
            return <ContentBlocks content={[target]} />
          },
        }
      })}
    </ContentDIV>
  )

export default Content